// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Phone_wrapper__3Ngv8"};